import { useEffect, useState } from "react";
import "./Navbar.css";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Hamburger from "hamburger-react";

import useLocalizedPath from "../../i18n/useLocalizedPath";
import locateLogo from "../../assets/images/Locate logo 3 1.webp";
import LanguageSelector from "../../UI/LanguageSelector";
import GlobalActionButton from "../../Reuseables/GlobalActionButton/GlobalActionButton";

const LINKS = [
  { path: "/", key: "home", end: true },
  { path: "/about", key: "about" },
  { path: "/portfolio", key: "portfolio" },
  { path: "/resource-centre", key: "resources" },
  { path: "/contacts", key: "contact" },
];

export default function Nav() {
  const { t } = useTranslation();
  const lp = useLocalizedPath();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Close the mobile menu whenever the page changes
  useEffect(() => setMenuOpen(false), [pathname]);

  // Soft shadow once the page scrolls under the header
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Lock page scroll behind the open menu; Escape closes it
  useEffect(() => {
    if (!menuOpen) return;
    document.body.style.overflow = "hidden";
    document.body.classList.add("site-menu-open");
    const onKeyDown = (e) => e.key === "Escape" && setMenuOpen(false);
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      document.body.classList.remove("site-menu-open");
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [menuOpen]);

  const renderLinks = (className) =>
    LINKS.map(({ path, key, end }) => (
      <NavLink key={key} to={lp(path)} end={end} className={className}>
        {t(`nav.${key}`)}
      </NavLink>
    ));

  return (
    <header
      className={`site-header ${scrolled ? "is-scrolled" : ""} ${
        menuOpen ? "is-open" : ""
      }`}
    >
      <div className="site-header-bar global-padding-5per-left-right">
        <NavLink to={lp("/")} className="site-header-logo">
          <img src={locateLogo} alt={t("logoAlt")} />
        </NavLink>

        <nav className="site-header-nav" aria-label={t("menu.label")}>
          {renderLinks("site-header-link")}
        </nav>

        <div className="site-header-actions">
          <LanguageSelector />
          <div className="site-header-toggle">
            <Hamburger
              size={22}
              rounded
              color="#363636"
              toggled={menuOpen}
              toggle={setMenuOpen}
              label={menuOpen ? t("menu.close") : t("menu.open")}
            />
          </div>
        </div>
      </div>

      <div
        id="site-header-menu"
        className="site-header-menu"
        aria-hidden={!menuOpen}
      >
        <nav className="site-header-menu-links" aria-label={t("menu.label")}>
          {renderLinks("site-header-menu-link")}
        </nav>
        <div className="site-header-menu-cta">
          <GlobalActionButton
            type="primary"
            to="/contacts"
            label={t("actions.bookDemo")}
          />
        </div>
      </div>

      <div
        className="site-header-backdrop"
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />
    </header>
  );
}
